export default function FloatingCTA() {
  return null;

  /* WhatsApp flutuante — desativado temporariamente
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5555997266310', '_blank');
  };

  return (
    <>
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all z-50 cursor-pointer group"
        aria-label="Entrar em contato via WhatsApp"
      >
        <i className="ri-whatsapp-fill text-3xl text-white"></i>
      </button>
    </>
  );
  */
}